<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <input class="form-control" :class="inputType" v-model="data[id]"></input>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'id',
            'data',
            'type'
        ],
        data() {
            return {
            };
        },
        computed: {
            inputType() {
                if (this.type === 'number') {
                    return 'filter-number'
                }
                return 'filter-text';
            }
        }
    }
</script>